// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/get_canvases_for_filter" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { analyticsDashboardAppGroupIdGetCanvasesForFilter } from "./constants";
import type { AnalyticsDashboardAppGroupIdGetCanvasesForFilterResult, FiltersParam } from "./types";

export const getAnalyticsDashboardAppGroupIdGetCanvasesForFilter = reactQueryFetcherAdapter(
  analyticsDashboardAppGroupIdGetCanvasesForFilter,
  (
    signal: AbortSignal,
    appGroupId: string,
    filters?: FiltersParam
  ): Promise<AnalyticsDashboardAppGroupIdGetCanvasesForFilterResult> => {
    return fetch(`/analytics_dashboard/${appGroupId}/get_canvases_for_filter`, "GET", { filters }, { signal });
  }
);
